Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('jsonforms.generators', []).name;
//# sourceMappingURL=generators.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/jsonforms/components/generators/generators.js
 ** module id = 825
 ** module chunks = 2
 **/